<template>
  <nav class="navbar navbar-light bg-light">
    <form @submit.prevent = "searchProduct" class="searchBar">
      <input
        v-model= "searchMin"
        class="form-control mr-sm-2"
        type="number"
        placeholder="Min.Price"
        aria-label="Search"
      />
      <input
        v-model= "searchMax"
        class="form-control mr-sm-2"
        type="number"
        placeholder="Max.Price"
        aria-label="Search"
      />
      <div class="searchSelect form-group">
        <!-- <label for="exampleFormControlSelect1">Example select</label> -->
        <select v-model= "categoryId" class="form-control"  >
            <option value= "" selected>Select Category</option>
            <option v-for= "category in categories" :key= "category.id" :value= "category.id">{{category.name}}</option>
        </select>
      </div>

      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">
        
        Search
      </button>
      <button @click= "clearSearch" class="btn btn-outline-success my-2 my-sm-0" type="button">
        
        Clear
      </button>
    </form>
  </nav>
</template>

<script>
export default {
  name: "SearchBar",
  data : function (){
    return {
      searchMin : '',
      searchMax : '',
      categoryId : ''
    }
  },
  computed : {
      categories(){
        return this.$store.state.categories;
      },
      
  },
  methods : {
    searchProduct(){
   
        let searchBy = {
          categoryId : this.categoryId,
          minPrice : this.searchMin,
          maxPrice : this.searchMax
        }
        this.$store.commit("SEARCH_FILTER", searchBy)
        this.$store.dispatch("fetchProducts");
        
    },
    clearSearch(){
  
        this.categoryId = ''
        this.minPrice = ''
        this.maxPrice = ''
        this.$store.commit("CLEAR_SEARCH")

        this.$store.dispatch("fetchProducts");

    }
  },
  created(){
 
      this.$store.dispatch("fetchCategories")
        this.$store.dispatch("fetchProducts");

  }
};
</script>

<style></style>
